module.exports = __webpack_public_path__ + "img/Group 102@2x.5f1c46f5.png";